import type { IFieldRequest as ISharedFieldRequest } from "@krea/shared/types/fieldRequest";

/* eslint-disable @typescript-eslint/naming-convention */
export enum FieldRequestFieldEnum {
  reason = "reason",
  reason_explanation = "reason_explanation",
  requested_amount = "requested_amount",
  repayment_time = "repayment_time",
  self_estimated_historic_revenue = "self_estimated_historic_revenue",
  self_estimated_revenue = "self_estimated_revenue",
  guarantors = "guarantors",
  accounting_data = "accounting_data",
  banking_data = "banking_data",
  property = "property",
  unpaid_invoices = "unpaid_invoices",
  unpaid_invoices_additional_data = "unpaid_invoices_additional_data",
  company_mortgage = "company_mortgage",
  additional_securities = "additional_securities",
  budget = "budget",
  suggested_amount = "suggested_amount",
  pawned_invoices = "pawned_invoices",
  parent_company_guarantee = "parent_company_guarantee",
  share_mortgage = "share_mortgage",
  refinancing = "refinancing",
  sale_of_property = "sale_of_property",
  property_cash_flow = "property_cash_flow",
  construction_completed_repayment = "construction_completed_repayment",
  construction_estimate = "construction_estimate",
  building_permit = "building_permit",
  grouped_real_estate_collateral = "grouped_real_estate_collateral",
  grouped_real_estate_repayment = "grouped_real_estate_repayment",
  refinancing_amounts = "refinancing_amounts",
  leasing = "leasing",
  leasing_additional_data = "leasing_additional_data",
  property_additional_data = "property_additional_data",
  annual_report = "annual_report",
  time_to_financing = "time_to_financing",
  profit_and_loss_prognosis = "profit_and_loss_prognosis",
}

export type IFieldRequest<T = unknown, C = unknown> = ISharedFieldRequest<
  T,
  C,
  FieldRequestFieldEnum
>;
